import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'

import { IOfferSettingsForm } from './types'
import { GTCompanyV2VerticalInput } from 'gql/types.generated'

const messages = defineMessages({
  requiredStartDate: {
    id: 'offerSettings.form.startDate.required',
    defaultMessage: 'The start date is required'
  },
  requiredActivePeriod: {
    id: 'offerSettings.form.activePeriod.required',
    defaultMessage: 'The active period is required'
  },
  requiredSalesChannels: {
    id: 'offerSettings.form.salesChannels.required',
    defaultMessage: 'The sales channels are required'
  },
  requiredBusinessClients: {
    id: 'offerSettings.form.businessClients.required',
    defaultMessage: 'The business clients are required'
  },
  requiredType: {
    id: 'offerSettings.form.type.required',
    defaultMessage: 'The type is required'
  }
})

export const offerSettingsSchema = (intl: IntlShape): yup.SchemaOf<IOfferSettingsForm> => {
  return yup.object().shape({
    isPrivate: yup.boolean().nullable().required(intl.formatMessage(messages.requiredType)),
    hasTolls: yup.boolean().required(),
    startDate: yup.date().required(intl.formatMessage(messages.requiredStartDate)),
    endDate: yup.date().optional(),
    activePeriod: yup.string().when('endDate', {
      is: (endDate?: Date | ''): TSFixMe => !endDate,
      then: (schema): TSFixMe => schema.required(intl.formatMessage(messages.requiredActivePeriod)),
      otherwise: (schema): TSFixMe => schema.optional()
    }),
    salesChannels: (yup.array() as yup.SchemaOf<IOfferSettingsForm['salesChannels']>).when('vertical', {
      is: (vertical: string): boolean => vertical !== GTCompanyV2VerticalInput.Rental,
      then: yup.array().min(1, intl.formatMessage(messages.requiredSalesChannels))
    }),
    businessClients: yup
      .array()
      .of(
        yup.object({
          id: yup.string().required(),
          name: yup.string().required()
        })
      )
      .when(['vertical', 'isPrivate'], {
        is: (vertical: string, isPrivate: boolean): boolean =>
          vertical === GTCompanyV2VerticalInput.Team ||
          vertical === GTCompanyV2VerticalInput.Rental ||
          (vertical === GTCompanyV2VerticalInput.City && isPrivate),
        then: yup.array().min(1, intl.formatMessage(messages.requiredBusinessClients))
      }),
    businessSites: yup.array().of(
      yup.object({
        id: yup.string().required(),
        name: yup.string().required(),
        clientId: yup.string().required()
      })
    )
  })
}
